import "./About";
import MyNavbar from "../../components/navbar/MyNavbar";
import Footer from "../../components/footer/Footer";
import { Container } from "react-bootstrap";

function About() {
  return (
    <>
      <MyNavbar />
      <Container>
        <h1 style={{fontFamily : 'serif'}}>About Udemy: </h1>
        <h3 className="my-4">Get the 2026 Global Learning & Skills Trends Report</h3>

        <p style={{ textAlign: "justify" }} className="py-4">
          If you or your organization are looking for help navigating change and AI transformation, you’ll find a roadmap for action in our popular annual report.. ✨
        </p>

        <h3>How to begin</h3>

        <p style={{ textAlign: "justify" }} className="py-4">
          We want to create a world where anyone can build something meaningful with technology, and everyone has the learning tools, resources, and opportunities to do so. Code contains a world of possibilities — all that’s required is the curiosity and drive to learn. At Codecademy, we are committed to empowering all people, regardless of where they are in their coding journeys, to continue to learn, grow, and make an impact on the world around them.This website is using a security service to protect itself from online attacks. The action you just performed triggered the security solution. There are several actions that could trigger this block including submitting a certain word or phrase, a SQL command or malformed data.You can email the site owner to let them know you were blocked. Please include what you were doing when this page came up and the Cloudflare Ray ID found at the bottom of this page You start with your passion and knowledge. Then choose a promising topic with the help of our Marketplace Insights tool.The way that you teach — what you bring to it — is up to you.We offer plenty of resources on how to create your first course. And, our instructor dashboard and curriculum pages help keep you organized.
        </p>
      </Container>

      <Footer />
    </>
  );
}
export default About;